import FreeProducts from './FreeProductsContainer';

export default FreeProducts;
